var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('button',{on:{"click":_vm.exportFile}},[_vm._v("导出PDF")]),_c('div',{staticClass:"test",attrs:{"id":"container"}},[_vm._v("\n    sdfsdf\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }